module.exports = __webpack_public_path__ + "static/img/Sam-Collins.80e6511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Collins.jpg
// module id = luG1
// module chunks = 0